import { DoneAll, Info } from "@mui/icons-material";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  ModalClose,
  ModalDialog,
  Typography,
} from "@mui/joy";

import { useCompetitionQuery, usePublishCompetitionResultsMutation } from "@/hooks/competitions";

import { useModal } from "./useModal";

export default function ConfirmPublishCompetitionResults({
  competitionUuid,
}: {
  competitionUuid: string;
}) {
  const { close, display: displayModal } = useModal();
  const { data: competition } = useCompetitionQuery(competitionUuid);
  const mutation = usePublishCompetitionResultsMutation(
    competition?.venues[0].uuid,
    competition?.league?.uuid,
  );

  const onConfirm = () => {
    if (!competition?.stages[0].uuid) {
      throw new Error("Stage UUID is missing");
    }
    mutation.mutate([competitionUuid, competition?.stages[0].uuid], {
      onSuccess: () => {
        close();
        // A parkrun hands the gym back its own routes, so there's nothing for
        // the organiser to strip. The competition's updated status is the
        // feedback.
        const isParkrun = competition?.settings?.customFormat === "TCH_PARKRUN";
        // Open the strip routes confirmation modal after successful publishing
        if (!isParkrun && competition?.venues[0].uuid && competition.climbType === "BOULDER") {
          displayModal("POST_CONFIRM_COMPETITION_RESULTS", {
            competitionUuid,
          });
        }
      },
      onError: (_err) => {
        alert("Failed to publish competition results. Please try again or contact support");
      },
    });
  };

  return (
    <ModalDialog>
      <ModalClose />
      <DialogTitle>Confirm results</DialogTitle>
      <DialogContent>
        <Typography sx={{ maxWidth: 400, mb: 2 }}>
          Are you sure you want to confirm the results and finalise the competition?
        </Typography>
        <Typography color="neutral" fontStyle="italic" startDecorator={<Info />}>
          A push notification will be sent to all competitors.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={onConfirm}
          sx={{ flex: 1 }}
          loading={mutation.isPending}
          startDecorator={<DoneAll />}
        >
          Publish
        </Button>
        <Button color="neutral" variant="soft" onClick={close} sx={{ flex: 1 }}>
          Cancel
        </Button>
      </DialogActions>
    </ModalDialog>
  );
}
